import React from 'react';

import { locale } from '@trqk/utils';
import { Button, IconSparkles } from '@trqk/components';

/**
 * Modal content that prompts the user to refresh their browser to get the latest version of the web
 * app.
 */
export const AppVersionStatusContent = (): JSX.Element => (
        <div
            className="rounded-lg bg-white p-10"
            style={{ width: 600, height: 360 }}
        >
            <div className="flex flex-col items-center mt-10">
                <h3 className="mb-10">
                    {locale.enUS.APP_VERSION_STATUS.UPDATE_AVAILABLE}
                </h3>

                <p className="italic text-tertiary-400 mt-3 mb-2 text-center w-2/3">
                    <IconSparkles
                        addClasses="mr-1"
                        fillColor="primary-500"
                        width={20}
                    />
                    {locale.enUS.APP_VERSION_STATUS.CLICK_TO_REFRESH}
                </p>

                <Button
                    addClasses="mt-4"
                    autoWidth={true}
                    color="primary-light-bg"
                    handleClick={(): void => {
                        window.location.reload();
                    }}
                >
                    {locale.enUS.APP_VERSION_STATUS.UPDATE_NOW}
                </Button>
            </div>
        </div>
    );
